
import { gql } from 'apollo-boost';

export const GET_COMPANY_QUERY = gql`
query company {
    company {
      id
      name
      status
      contactEmailAddress
      defaultLocaleCode
      variableList {
        name
        value
      }
    }
  }`;